import { render, staticRenderFns } from "./contragent-info.vue?vue&type=template&id=6a74128c"
import script from "./contragent-info.vue?vue&type=script&lang=js"
export * from "./contragent-info.vue?vue&type=script&lang=js"
import style0 from "./contragent-info.vue?vue&type=style&index=0&id=6a74128c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports